export default __webpack_public_path__ + "static/media/1_Intro.ce933e2c.mp4";